import React, { useState, useEffect } from "react";
import { useParams } from "@reach/router";
import Footer from "../components/footer";
import { createGlobalStyle } from "styled-components";
import { GenericModal, LoadingModal } from "../ui/Modals";

import axios from "axios";
import { create } from "ipfs-http-client";
import dw from "web-digital-watermarking";
import { LicensesTemplate } from "../components/licenseTemplate";

import { utils } from "ethers";
import { useEthers } from "@usedapp/core";
import { useContractFunction } from "@usedapp/core";
import { useContractContext } from "../../hooks/useContractContext";

// https://www.youtube.com/watch?v=0W6i5LYKCSI
// create a redux store for your items
// either that or consider using react-router
// or both

const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.white {
    background: #FAF6F1;
    border-bottom: solid 1px #ccc !important;
  }
`;

const ViewItem = () => {
  const { account, activateBrowserWallet } = useEthers();
  const {
    copyrightsContract,
    licensesContract,
    marketplaceContract,
    contractAddr,
  } = useContractContext();

  const formatIpfsUrl = (url) => {
    return url.replace(/ipfs:\/\//g, "https://nftstorage.link/");
  };
  const infufaClient = create("https://ipfs.infura.io:5001/api/v0");

  const [openMenu, setOpenMenu] = useState(true);
  const [openMenu1, setOpenMenu1] = useState(false);

  const handleBtnClick = () => {
    setOpenMenu(!openMenu);
    setOpenMenu1(false);

    document.getElementById("Mainbtn").classList.add("active");
    document.getElementById("Mainbtn1").classList.remove("active");
  };

  const handleBtnClick1 = () => {
    setOpenMenu1(!openMenu1);
    setOpenMenu(false);

    document.getElementById("Mainbtn1").classList.add("active");
    document.getElementById("Mainbtn").classList.remove("active");
  };

  const params = useParams();
  const tokenId = params.tokenId;

  const [licPrice0, setLicPrice0] = useState();
  const [licPrice1, setLicPrice1] = useState();
  const [pendingWalletApproval, setPendingWalletApproval] = useState();
  const [ownerIsBuyer, setOwnerIsBuyer] = useState();
  const [isLoading, setisLoading] = useState(false);

  const [ETHSGD, setETHSGD] = useState();
  const [metaData, setMetaData] = useState();
  const [detailsOfWork, setDetailsOfWork] = useState({
    creatorPseudonym: "",
    workFormat: "",
    yearCreated: "",
    workIpfsCid: "",
  });
  const [saleItem, setSaleItem] = useState({
    itemId: "",
    NFTContract: "",
    tokenId: "",
    seller: "",
    price: null,
    forSale: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      setETHSGD(
        (
          await axios.get(
            "https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=SGD"
          )
        ).data.SGD
      );
      setDetailsOfWork(await copyrightsContract.checkDetailsOfWork(tokenId));
      const ipfsUri = await copyrightsContract.tokenURI(tokenId);
      const formattedUri = formatIpfsUrl(ipfsUri);
      setMetaData((await axios.get(formattedUri)).data);
      getSaleItemDetails();
      setLicPrice0(await getProductPrice(0));
      setLicPrice1(await getProductPrice(1));
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [licPrice0, licPrice1]);

  const getSaleItemDetails = async () => {
    setSaleItem(
      await marketplaceContract.getMarketItem(
        copyrightsContract.address,
        tokenId
      )
    );
  };

  const getProductPrice = async (configNum) => {
    let productDetails = await licensesContract.getProductTemplate(
      contractAddr.copyrights,
      tokenId,
      configNum
    );
    let price = utils.formatEther(productDetails.price);
    return price;
  };

  const uploadtoIPFS = async (file) => {
    try {
      setisLoading(true);
      const added = await infufaClient.add(file);
      console.log(`https://nftstorage.link/ipfs/${added.path}`);
      setisLoading(false);
      return await added.path;
    } catch (error) {
      console.log("Error uploading file: ", error);
    }
  };

  const encodeFunc = async (imgHTMLAddress, watermarkText) => {
    setisLoading(true);
    console.log("triggered encode function");
    var canvas = await fetch(imgHTMLAddress);
    var canvasBlob = await canvas.blob();
    var watrmarkfontSize = 2.15;
    var imageObjectURL = URL.createObjectURL(canvasBlob);
    const enCodeImageUrl = await dw.transformImageUrlWithText(
      imageObjectURL,
      watermarkText,
      watrmarkfontSize
    );
    console.log(enCodeImageUrl);
    setisLoading(false);
    return enCodeImageUrl;
  };

  const { state: purchaseLicenseState, send: sendPurchaseLicense } =
    useContractFunction(licensesContract, "purchaseLicense");
  const { state: triggerSaleState, send: sendTriggerSale } =
    useContractFunction(marketplaceContract, "triggerSale");

  const purchaseLicenseNow = async (price, configNum) => {
    if (!account) {
      activateBrowserWallet();
    }
    if (account === (await copyrightsContract.ownerOf(tokenId))) {
      const message = "The license buyer cannot be the same as the owner";
      console.log(message);
      setOwnerIsBuyer(true);
      return (
        <GenericModal
          message="The license buyer cannot be the same as the owner"
          buttonText="close"
        ></GenericModal>
      );
    }

    if (account) {
      // Encode image with signer address hash
      const cloudfarePicUrl = formatIpfsUrl(detailsOfWork.workIpfsCid);
      const enCodeImageUrl = await encodeFunc(
        cloudfarePicUrl,
        account.toString()
      );
      // convert base64url data structure to blob
      let blob = await fetch(enCodeImageUrl).then((r) => r.blob());
      // upload blob to IPFS
      const licensedPictureCID = await uploadtoIPFS(blob);

      const copyrightOwner = await copyrightsContract.ownerOf(tokenId);
      const licenseReceiver = account.toString();
      const duration_days = 365;

      const licenseAgreement = LicensesTemplate(
        copyrightOwner,
        licenseReceiver,
        duration_days
      );
      const licenseMetaDataJson = JSON.stringify({
        imageCID: `ipfs://ipfs/${licensedPictureCID}`,
        licenseAgreement,
      });
      const licenseMetaDataJsonCID = await uploadtoIPFS(licenseMetaDataJson);
      const LicenseURI = `ipfs://ipfs/${licenseMetaDataJsonCID}`;

      const priceInWei = utils.parseEther(price);
      setPendingWalletApproval(true);
      // eslint-disable-next-line
      const tx = await sendPurchaseLicense(
        contractAddr.copyrights,
        tokenId,
        configNum,
        duration_days,
        LicenseURI,
        {
          value: priceInWei,
        }
      );
    }
    setPendingWalletApproval(false);
  };

  const buyCopyrightOwnership = async (saleItemPrice) => {
    await sendTriggerSale(contractAddr.copyrights, tokenId, {
      value: saleItemPrice,
    });
  };

  return (
    <div>
      <GlobalStyles />

      <section className="container">
        {purchaseLicenseState.status === "Mining" && (
          <GenericModal title={"Mining Transaction..."} />
        )}
        <div className="row mt-md-5 pt-md-4">
          <div className="col-md-6 text-center">
            <img
              src={formatIpfsUrl(detailsOfWork.workIpfsCid)}
              className="img-fluid img-rounded mb-sm-30"
              alt=""
            />
          </div>
          <div className="col-md-6">
            <div className="item_info">
              <h2>{metaData === undefined ? "fetching" : metaData.title}</h2>
              <div className="item_info_counts">
                <div className="item_info_type">
                  <i className="fa fa-image"></i>Artistic, Image
                </div>
              </div>
              <p>
                {metaData === undefined ? "fetching" : metaData.description}
              </p>
              <h4>Creator</h4>
              <div className="item_author">
                <div className>
                  <span>{detailsOfWork.creatorPseudonym}</span>
                </div>
              </div>
              <div className="spacer-20"></div>
              <div className="de_tab">
                <ul className="de_nav">
                  <li id="Mainbtn" className="active">
                    <span onClick={handleBtnClick}>Licenses</span>
                  </li>
                  <li id="Mainbtn1">
                    <span onClick={handleBtnClick1}>
                      Buy Copyright Ownership
                    </span>
                  </li>
                </ul>

                <div className="de_tab_content">
                  {openMenu && (
                    <div className="tab-2 onStep fadeIn">
                      <h5> Licenses</h5>
                      <div>
                        <span>
                          Permissions given by the copyright holder for their
                          content. Licenses can be applied to copyrighted
                          material to give permission for certain uses of the
                          material.
                        </span>
                      </div>

                      {licPrice0 !== undefined && licPrice0 > 0 && (
                        <div>
                          <div className="spacer-20"></div>
                          <div className="nft__item_price row-eq-height">
                            <h6>License configuration 1</h6>
                            Duration : 1 year (365 days)
                            <button
                              className="btn-main p-2"
                              onClick={() => purchaseLicenseNow(licPrice0, 0)}
                              disabled={
                                purchaseLicenseState.status === "Mining" ||
                                ownerIsBuyer === true
                              }
                            >
                              Purchase Now
                            </button>
                            <br />
                            Price : {(licPrice0 * 1).toFixed(5)} ETH ={" "}
                            {(licPrice0 * ETHSGD).toFixed(2)} SGD
                            <div className="spacer-10"></div>{" "}
                            {isLoading && !pendingWalletApproval && (
                              <GenericModal
                                title={"Loading..."}
                                message={
                                  "Please get ready to approve the transaction on your wallet"
                                }
                              />
                            )}
                            {isLoading && pendingWalletApproval && (
                              <GenericModal
                                title={"Action Required:"}
                                message={
                                  "Please approve purchase on your wallet"
                                }
                              />
                            )}
                            {ownerIsBuyer === true &&
                              "Owners of the copyright cannot purchase a license to their owned copyrights"}
                          </div>
                        </div>
                      )}

                      {licPrice1 !== undefined && licPrice1 > 0 && (
                        <div>
                          <div className="spacer-20"></div>
                          <div className="nft__item_price row-eq-height">
                            <h6>License configuration 2</h6>
                            Duration : 1 year (365 days)
                            <span
                              className="btn-main p-2"
                              onClick={() => purchaseLicenseNow(licPrice1)}
                            >
                              Purchase Now
                            </span>
                            <br />
                            Price : {(licPrice1 * 1).toFixed(5)} ETH ={" "}
                            {(licPrice1 * ETHSGD).toFixed(2)} SGD
                            <div className="spacer-10"></div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {openMenu1 && (
                    <div className="tab-2 onStep fadeIn">
                      {isLoading && (
                        <LoadingModal title={"Loading..."}></LoadingModal>
                      )}
                      {saleItem.forSale === false && <div>Not for sale</div>}
                      {saleItem.forSale === true && (
                        <div className="nft__item_price row-eq-height">
                          ETHSGD rate: {ETHSGD}
                          <br />
                          <b>Current Price : </b>
                          {saleItem.price === null
                            ? ""
                            : (utils.formatEther(saleItem.price) * 1).toFixed(
                                4
                              )}{" "}
                          (ETH)
                          <br />
                          <b>Convert to (SGD) Price : </b>
                          {saleItem.price === null
                            ? ""
                            : (
                                utils.formatEther(saleItem.price) * ETHSGD
                              ).toFixed(2)}{" "}
                          SGD
                          <br />
                          <div className="spacer-10"></div>
                          <button
                            disabled={triggerSaleState.status === "Mining"}
                            type="button"
                            className="btn-main p-2"
                            onClick={() =>
                              buyCopyrightOwnership(saleItem.price)
                            }
                          >
                            Buy Over Copyright
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};
export default ViewItem;
